import { render } from "./Advs.vue?vue&type=template&id=90497a5c&scoped=true"
import script from "./Advs.vue?vue&type=script&lang=js"
export * from "./Advs.vue?vue&type=script&lang=js"

import "./Advs.vue?vue&type=style&index=0&id=90497a5c&lang=less&scoped=true"

import exportComponent from "E:\\wwwroot\\abz-shuzi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90497a5c"]])

export default __exports__